export default {
  faqs: [],
  pagination: {},
  faq: {}
}
